import React from "react";
import styled from "styled-components";
import Video from "konnekt/Video";

import AudioPlayer from "konnekt/Message/components/AudioMessage";
import { getPreview, getFileType } from "util/utility";
import { getHTMLDecodedText } from "util/chatUtil";
import useIsActiveConversationInsta from "customHooks/inbox/useIsActiveConversationInsta";

const Image = styled.img`
  max-width: ${(props) => (props.doc ? "120px" : "100%")};
  width: ${(props) => (props.doc ? "120px" : "unset")};
  max-height: 100%;
  transform: rotate(${(props) => props.rotate}deg);
  transition: transform 0.2s ease-in-out;
`;

const AudioPlayerBox = styled.div`
  background-color: #278351;
  padding: 30px;
  border-radius: 13px;
  max-width: 100%;
`;

const Media = ({ source, contentType, rotate, ...rest }) => {
  const fileType = getFileType(source) ?? contentType;

  const isChatOfInsta = useIsActiveConversationInsta();

  let media = "";

  if (source) {
    media = getHTMLDecodedText(source) || URL.createObjectURL(source);
  }

  if (fileType === "Video" || contentType === "Video") {
    return (
      <Video
        src={media}
        height="100%"
        maxWidth="100%"
        objectFit="cover"
        {...rest}
      />
    );
  }

  if (fileType === "Audio" || contentType === "Audio") {
    return (
      <AudioPlayerBox>
        <AudioPlayer
          variant="light"
          mediaURL={media}
          width="320px"
          maxWidth="100%"
          {...rest}
        />
      </AudioPlayerBox>
    );
  }

  return (
    <Image
      doc={fileType !== "Image"}
      rotate={rotate}
      src={isChatOfInsta ? source : getPreview(source)}
      alt={source}
      {...rest}
    />
  );
};

export default Media;
